import { useEffect, useRef } from 'react'
import { X } from 'react-feather'
// import { ImageBaseUrl } from '../../../../constants'
import { useAppDispatch, useAppSelector } from '../../../../redux/hooks'
import { setProfileToggle } from '../../../../redux/reducers/messenger/messengerSlice'
import { Image } from '../../../../shared/image'
import ContactIcon from './ContactIcon'
import ContactInformation from './ContactInformation'
import GroupChat from './GroupChat'
import Messages from './Messages'
import SharedMedia from './SharedMedia'
import SharedDocument from './SharedDocument'
import { hideOtherFeature } from '../../../../constants'
import '../../../../utils/prototype'
import { setViewProfile } from '../../../../redux/reducers/messenger/chatSlice'
import { ChatMembersType } from '../../../../types/store'

const ProfileSection = () => {
  const { selectedUserProfile, selectedUser } = useAppSelector((state) => state.chat)
  const { profileToggle } = useAppSelector((state) => state.messenger)
  const { app_name } = useAppSelector((state) => state.settings)
  const dispatch = useAppDispatch()

  const sidebarRef = useRef<HTMLDivElement | null>(null)

  const handleClose = () => {
    dispatch(setProfileToggle(false))
  }

  function getEventPathFallback(event: Event): EventTarget[] {
    const path: EventTarget[] = []
    let target = event.target as Node | null

    while (target) {
      path.push(target)
      target = (target as Node).parentNode
    }

    path.push(window)
    return path
  }
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      // Skip if delete modal is open
      if (document.querySelector('.custom-delete-modal')) return

      const sidebarEl = sidebarRef.current
      if (!sidebarEl) return

      // SAFELY get event path (Shadow DOM compatible)
      const path = typeof event.composedPath === 'function' ? event.composedPath() : getEventPathFallback(event)
      // If click happened inside sidebar → do nothing
      if (path.includes(sidebarEl)) return

      // Outside click
      handleClose()
    }

    document.addEventListener('mousedown', handleClickOutside, true)

    return () => {
      document.removeEventListener('mousedown', handleClickOutside, true)
    }
  }, [profileToggle])

  if (!profileToggle) return null

  const handleViewProfile = () => {
    dispatch(setViewProfile(selectedUser as ChatMembersType))
  }

  return (
    <aside className="meetzy-right-sidebar active" ref={sidebarRef}>
      <div className="custom-scroll right-sidebar">
        <div className="contact-profile-img">
          <div className={`profile`}>
            <Image src={selectedUserProfile?.avatar} onClick={handleViewProfile} />
            <a className="icon-btn btn-sm close-profile" onClick={handleClose}>
              <X />
            </a>
            <div className="profile-content">
              <h4 className="text-white" onClick={handleViewProfile}>
                {selectedUser?.isAnnouncement ? app_name : selectedUserProfile?.name?.firstTwoWords()}
              </h4>
              {!hideOtherFeature.hideContactPhoneNumber &&
                !selectedUser?.isAnnouncement &&
                selectedUserProfile?.phone && (
                  <p className="text-white mb-0 d-flex align-items-center gap-2">
                    {!selectedUserProfile?.userSetting?.hide_phone && `+${selectedUserProfile?.phone}`}
                  </p>
                )}
            </div>
          </div>
        </div>
        <ContactIcon />
        <SharedDocument />
        <SharedMedia />
        <Messages />
        {!hideOtherFeature.hideGroup && !selectedUser?.isAnnouncement && <GroupChat />}
        <ContactInformation />
      </div>
    </aside>
  )
}

export default ProfileSection
